function AstraPayLogoDisabled({
  width = '24',
  height = '23',
}: {
  width?: string;
  height?: string;
}) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 23"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M23.23 13.61L16.9234 2.81033C14.7355 -0.936776 9.26492 -0.936776 7.07621 2.81033L0.770409 13.61C-1.4183 17.3571 1.31699 22.0411 5.69441 22.0411H18.306C22.6827 22.0411 25.4179 17.3571 23.23 13.61Z"
        fill="#F4F4F4"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17.6187 18.13C16.4736 18.9013 14.6301 19.1019 13.2861 17.7147L12.5814 16.9877C12.4422 16.8439 12.2354 16.7614 12.0167 16.7614C11.7981 16.7614 11.5921 16.8439 11.4529 16.9877L10.6294 17.8368C9.99634 18.49 9.14774 18.8492 8.24017 18.8492C7.76357 18.8492 7.29642 18.7505 6.8505 18.5553C5.57487 17.9947 4.84268 16.8058 4.93941 15.452C4.9811 14.8844 5.15018 14.3448 5.44196 13.8456L8.74193 8.19422C9.42614 7.0232 10.6515 6.32417 12.0175 6.32417C13.3844 6.32417 14.6081 7.0232 15.2915 8.19422L18.5931 13.8471C18.6536 13.9513 18.7079 14.0547 18.7559 14.1589C19.5423 15.8408 18.7512 17.3656 17.6187 18.13ZM23.23 13.61L16.9234 2.81033C14.7355 -0.936776 9.26492 -0.936776 7.07621 2.81033L0.770409 13.61C-1.4183 17.3571 1.31699 22.0411 5.69441 22.0411H18.306C22.6827 22.0411 25.4179 17.3571 23.23 13.61Z"
        fill="#918F8F"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17.293 14.8265C17.2639 14.765 17.2317 14.7028 17.1963 14.6414L13.8971 8.9893C13.5039 8.31826 12.8008 7.91626 12.0167 7.91626C11.2318 7.91626 10.5287 8.31826 10.1363 8.9893L6.83551 14.643C6.66563 14.9322 6.56811 15.2417 6.54531 15.5644C6.48868 16.3606 7.00224 16.8793 7.50321 17.0985C8.18743 17.4002 8.95894 17.2564 9.4662 16.7338L10.2889 15.8855C11.2011 14.9462 12.8323 14.9462 13.743 15.8855L14.4476 16.611C15.1484 17.3334 16.0882 17.2338 16.7095 16.8139C16.9014 16.6849 17.8325 15.9796 17.293 14.8265Z"
        fill="#918F8F"
      />
    </svg>
  );
}

export default AstraPayLogoDisabled;
